import * as React from 'react';
import { memo } from 'react';

const SvgClipboardText = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.875 14h6.5M5.875 10.75h6.5M12.375 2.625h4.063a.812.812 0 0 1 .812.813V20.5a.813.813 0 0 1-.813.813H1.813A.813.813 0 0 1 1 20.5V3.437a.812.812 0 0 1 .813-.812h4.062", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.063 5.875v-.813a4.063 4.063 0 0 1 8.125 0v.813H5.062Z", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgClipboardText);

export { Memo as default };
